import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { unAuthApi } from 'boot/receiver/axios'

import { useUserStore } from 'stores/receiver/account/user/user'
import { useErrorStore } from '../common/error'

import type { FetchPublicKeysRes } from 'types/receiver/account/auth'

export const useConfigStore = defineStore('config', () => {
  const senderBaseUrl = computed(() => {
    return process.env.SENDER_URL?.replace(
      '{handle}',
      useUserStore().activeOrganisation?.handle || ''
    )
  })

  // Public keys
  const jwt_public_key = ref<null | string>(null)
  const recaptcha_key = ref<null | string>(null)
  // Free permissions
  const freePermissions = ref<string[]>([])

  const fetchReceiverConfig = async () => {
    try {
      const res = await unAuthApi.get('/account/configuration')

      const data: FetchPublicKeysRes = res?.data
      if (data && data.success) {
        jwt_public_key.value = data.payload.keys.jwt_public_key
        recaptcha_key.value = data.payload.keys.recaptcha_key
        freePermissions.value = data.payload.free_permissions.map(
          (permission) => permission.name
        )
      }
      return res.status >= 200 && res.status < 300
    } catch (error) {
      useErrorStore().updateBackErrors(error)
      return false
    }
  }

  // STORE RESET
  // Used to reset the store (is given by default by pinia on options api stores but not on composition api stores)
  const $reset = () => {
    jwt_public_key.value = null
    recaptcha_key.value = null
    freePermissions.value = []
  }

  return {
    senderBaseUrl,
    jwt_public_key,
    recaptcha_key,
    freePermissions,
    fetchReceiverConfig,
    $reset,
  }
})
